/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import {
  Component, Input, OnChanges, OnInit, SimpleChanges,
} from '@angular/core';
import { AttributionPosition } from '../cover-image/cover-image.component';
import { ImageAsset, ImageEffect } from '../types';

@Component({
  selector: 'bulb-header-image',
  templateUrl: './header-image.component.html',
  styleUrls: ['./header-image.component.scss'],
  standalone: false,
})
export class HeaderImageComponent implements OnChanges, OnInit {

  @Input() imageAsset: ImageAsset;

  @Input() imageEffect: ImageEffect = 'NO_EFFECT';

  public imageZoom: boolean;

  public attPosition: AttributionPosition = AttributionPosition.topRight;

  ngOnInit(): void {
    this.imageZoom = this.imageEffect === 'ZOOM_OUT';
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Fixes changing from parallax/no-effect to zoom causing cover-image--scale to appear erroneously.
    if (!changes.imageEffect.firstChange) {
      this.imageZoom = false;
    }
  }
}
